import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {SecurityService} from '../../services/settings/security.service';
import {Router} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  userName: string;
  password: string;

  constructor(private securitySvc: SecurityService,
              private router: Router) {
  }

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      this.securitySvc.login(this.userName, this.password).subscribe({
        next: appUser => {
          this.router.navigate(['ng/home'],  { queryParams: { openCS: true } });
        },
        error: err => {
          this.showError(err.message);
        }
      });
    }
  }

  private showError(errorMsg: string) {
    Swal.fire({
      title: 'Login failed',
      text: errorMsg,
      icon: 'error',
      showCancelButton: false,
      confirmButtonColor: '#5bc0de',
      cancelButtonColor: '#d33',
      confirmButtonText: 'U redu'
    }).then(() => {
    });
  }
}
